import { styled } from '@linaria/react';
import { Button } from '@mui/material';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { layersQuery } from '../../../../core/mapV2/queries';
import { layersReset } from '../../../../core/mapV2/state';
import { useAppDispatch, useAppSelector } from '../../../../types';
import { ElementaryDataSection } from './ElementaryDataSection';
import { LayerCard } from './LayerCard';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 12px;
`;

const Footer = styled.div`
    display: flex;
    justify-content: center;
    padding: 4px 12px 16px;
`;

// Expanded content of the left panel: the four layer cards (Sessions, Référentiel, État du réseau,
// Projets), then the elementary data section.
export const LayersPanel: FC = () => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const layers = useAppSelector(layersQuery);

    return (
        <>
            <Wrapper data-testid="map-v2-layers">
                {layers.map((layer) => (
                    <LayerCard key={layer.key} layer={layer} />
                ))}
            </Wrapper>
            <ElementaryDataSection />
            <Footer>
                <Button size="small" onClick={() => dispatch(layersReset())} sx={{ textTransform: 'none' }}>
                    {t('mapV2.layers.resetAll')}
                </Button>
            </Footer>
        </>
    );
};
